import cx from "classnames";
import {
  Button,
  Modal,
  TranslatedString,
  Card,
  FlexBox,
  Input,
  Image,
} from "components";
import React, { useState } from "react";
import "./styles.scss";
import { SampleModalProps } from "./types";
import TrustLogo from "assets/trust-logo-without-bg.svg";
const SampleModal: React.FC<SampleModalProps> = ({
  visible,
  onClose,
  action,
}) => {
  const [email, setEmail] = useState("");

  return (
    <Modal
      modalHeader={""}
      onClose={onClose}
      visible={visible}
      className="EmailRegistration-modal"
    >
      <Card className="pd-0">
        <FlexBox flexColumn justifyBetween alignCenter className="content">
          <div className="w-100 text-center bg-theme img-div">
            <Image src={TrustLogo} className="w-30" />
          </div>
          <div className="mr-t-40 w-80 input-box br-60 pd-10 bg-theme">
            <Input
              type={"text"}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              placeholder={"Your Work Email"}
              className="no-border text-center"
            />
          </div>
          <Button
            text={`Get ${window.screen.width < 968 ? "" : "Your"} API Key`}
            className="fs-18 br-60 clr-white w-40 no-wrap mr-v-40"
          />
        </FlexBox>
      </Card>
    </Modal>
  );
};
export default SampleModal;
